import {
  ArticleQuery,
  ChoicesArticlesFilter,
  ChoicesComponentFilter,
} from "@generated"
import { BaseRouter } from "next/dist/next-server/lib/router/router"

export function getFixedMaterial(
  query: BaseRouter["query"],
  baseData: ArticleQuery,
  component: ChoicesComponentFilter
): ChoicesArticlesFilter["material"] | null {
  const isStone = component === ChoicesComponentFilter.Stone
  const isHippieChicEarring =
    query?.type === "earring" && query?.style === "hippiechic"
  const baseMaterial = baseData?.choicesArticle?.material

  if (isHippieChicEarring && baseMaterial && isStone) {
    return baseMaterial as ChoicesArticlesFilter["material"]
  }

  return null
}
